import { useState } from "react";
import { Link } from "react-router-dom";
import { Leaf, Menu, X } from "lucide-react";

const links = [
    { label: "Home", href: "/#home", id: "nav-home-link" },
    { label: "About", href: "/#about", id: "nav-about-link" },
    { label: "Contact", href: "/#contact", id: "nav-contact-link" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);

    return (
        <header className="sticky top-0 z-50 bg-background border-b border-border">
            <nav className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
                <Link
                    to="/"
                    data-testid="nav-logo-link"
                    className="flex items-center gap-2 font-heading font-semibold text-lg text-primary"
                    onClick={() => setOpen(false)}
                >
                    <Leaf className="h-5 w-5" aria-hidden="true" />
                    Dirt Cheapest Sod Corp
                </Link>
                <div className="hidden md:flex items-center gap-8">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={l.id}
                            className="text-sm font-medium text-foreground hover:text-primary transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href="/#contact"
                        data-testid="nav-contact-cta"
                        className="rounded-full bg-primary text-primary-foreground text-sm font-medium px-5 py-2 hover:opacity-90 transition-opacity"
                    >
                        Get in Touch
                    </a>
                </div>
                <button
                    type="button"
                    data-testid="nav-mobile-menu-button"
                    aria-label={open ? "Close menu" : "Open menu"}
                    aria-expanded={open}
                    className="md:hidden p-2 text-foreground"
                    onClick={() => setOpen(!open)}
                >
                    {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                </button>
            </nav>
            {open && (
                <div
                    data-testid="nav-mobile-menu"
                    className="md:hidden border-t border-border bg-background px-4 py-4 flex flex-col gap-4"
                >
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`${l.id}-mobile`}
                            className="text-base font-medium text-foreground"
                            onClick={() => setOpen(false)}
                        >
                            {l.label}
                        </a>
                    ))}
                </div>
            )}
        </header>
    );
};
